import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20motherhood%20scene%20with%20soft%20cream%20and%20blush%20pastel%20background%2C%20gentle%20abstract%20flowing%20shapes%20reminiscent%20of%20mother%20and%20child%20embrace%2C%20artistic%20illustration%20style%20with%20soft%20textures%2C%20warm%20nurturing%20atmosphere%2C%20elegant%20and%20serene%2C%20no%20text%20no%20words&width=1600&height=800&seq=hero-motherhood-01&orientation=landscape"
        alt="年轻的妈妈育儿指导"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/35"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          年轻的妈妈
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-2 max-w-2xl">
          新手育儿全攻略
        </p>
        <p className="text-sm md:text-base text-white/75 max-w-xl mb-8">
          涵盖新生儿护理、产后恢复、母乳喂养、宝宝早教及妈妈自我成长，<br className="hidden sm:block" />
          帮助每一位年轻的妈妈从容应对育儿挑战
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/newborn-care"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}